import React, { Component } from 'react'
import { connect } from 'react-redux'
import FocusTrap from 'focus-trap-react'
import PropTypes from 'prop-types'
import { commonActions } from 'srcReact/components/actions'
import Icon from 'srcReact/components/icons/Icon'

class PopinComponent extends Component {
  constructor(props) {
    super(props)
  }

  handleClosePopin = (e) => {
    const { closePopin, closeCallback } = this.props
    e.stopPropagation()
    e.preventDefault()
    if (closeCallback) {
      closeCallback()
    }
    closePopin()
  }

  handleKeyPressed = (e) => {
    if (e.key === 'Escape') this.handleClosePopin(e)
  }

  isOpen = () => {
    const { openedPopinName, name, names } = this.props
    return openedPopinName === name || (names && names.includes(openedPopinName))
  }

  currentName = () => {
    const { name, openedPopinName } = this.props
    return name || openedPopinName
  }

  componentWillUnmount() {
    const { closePopin } = this.props

    closePopin()
  }

  render() {
    const { isPopinOpen, children, isWithoutClose, styleModifier, popinContentCss } = this.props
    const currentName = this.currentName()

    return (
      <div
        className={`popin-wrappper${isPopinOpen && this.isOpen() ? ' is-open' : ''}${
          styleModifier ? ` ${styleModifier}` : ''
        }`}
        role='dialog'
        aria-label='Popin'>
        {isPopinOpen && this.isOpen() ? (
          <FocusTrap>
            <div className='popin' onKeyUp={(e) => this.handleKeyPressed(e)}>
              <div className='popin-overlay' onClick={(e) => this.handleClosePopin(e)} />
              <div className={`popin-content ${popinContentCss}`}>
                {!isWithoutClose && (
                  <button title='close' className='popin-content--close' onClick={(e) => this.handleClosePopin(e)}>
                    <Icon name='close' alt='close' size='large' />
                  </button>
                )}

                <div className={`popin-content--wrapper ${currentName && currentName.length > 0 ? currentName : ''}`}>
                  {children}
                </div>
              </div>
            </div>
          </FocusTrap>
        ) : null}
      </div>
    )
  }
}
PopinComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element.isRequired]),
  name: PropTypes.string.isRequired,
  isWithoutClose: PropTypes.bool
}

PopinComponent.defaultProps = {
  isWithoutClose: false
}

const mapStateToProps = (state) => {
  const { isPopinOpen, openedPopinName } = state.common
  return { isPopinOpen, openedPopinName }
}

const actionCreators = {
  setIsMobile: commonActions.setIsMobile,
  closePopin: commonActions.closePopin
}

const connectedPopinComponent = connect(mapStateToProps, actionCreators)(PopinComponent)
export { connectedPopinComponent as PopinComponent }
